import { useState, useEffect } from 'react';
import { getHeroSlides } from '../services/api';

export const useHeroSlides = () => {
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    let timeoutId = null;

    const fetchHeroSlides = async () => {
      try {
        setLoading(true);

        // Небольшая задержка для стабилизации компонента
        await new Promise(resolve => {
          timeoutId = setTimeout(resolve, 50);
        });

        if (!mounted) return;

        const data = await getHeroSlides();

        if (mounted) {
          setSlides(data.data || []);
          setError(null);
          setLoading(false);
        }
      } catch (err) {
        if (mounted) {
          setError(err.message);
          setLoading(false);
        }
      }
    };

    fetchHeroSlides();

    return () => {
      mounted = false;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return { slides, loading, error };
};
